'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _user = require('../../redux/modules/user');

var _config = require('../../redux/modules/config');

var _browser = require('../../redux/modules/browser');

var _whiteLabel = require('../../redux/modules/whiteLabel');

var _modal = require('../../redux/modules/modal');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _AppHeaderMeta = require('./AppHeaderMeta');

var _AppHeaderMeta2 = _interopRequireDefault(_AppHeaderMeta);

var _Auth = require('./Auth');

var _Auth2 = _interopRequireDefault(_Auth);

var _BackToTop = require('../../components/BacktoTop/BackToTop');

var _BackToTop2 = _interopRequireDefault(_BackToTop);

var _BannerOutdatedBrowser = require('../../components/BannerOutdatedBrowser/BannerOutdatedBrowser');

var _BannerOutdatedBrowser2 = _interopRequireDefault(_BannerOutdatedBrowser);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _universalCookie = require('universal-cookie');

var _universalCookie2 = _interopRequireDefault(_universalCookie);

var _DeskPopup = require('../../components/DeskPopup/DeskPopup');

var _DeskPopup2 = _interopRequireDefault(_DeskPopup);

var _Footer = require('../../components/Footer/Footer');

var _Footer2 = _interopRequireDefault(_Footer);

var _FullStory = require('../../components/FullStory/FullStory');

var _FullStory2 = _interopRequireDefault(_FullStory);

var _getBrowserDataFromUA = require('../../utils/getBrowserDataFromUA');

var _pagination = require('../../utils/pagination');

var _windowSize = require('../../redux/modules/windowSize');

var _GoogleTagManager = require('../../components/GTM/GoogleTagManager');

var _GoogleTagManager2 = _interopRequireDefault(_GoogleTagManager);

var _Header = require('../../components/Header/Header');

var _Header2 = _interopRequireDefault(_Header);

var _client = require('../../redux/modules/client');

var _script = require('../../utils/script');

var _Modals = require('../../components/Modals/Modals');

var _Modals2 = _interopRequireDefault(_Modals);

var _boomerang = require('../../utils/boomerang.js');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _analytics = require('../../redux/modules/analytics');

var _SailthruInit = require('../../components/Sailthru/SailthruInit');

var _SailthruInit2 = _interopRequireDefault(_SailthruInit);

var _reactRouterScroll = require('react-router-scroll');

var _SegmentTracker = require('../../components/Segment/SegmentTracker');

var _SegmentTracker2 = _interopRequireDefault(_SegmentTracker);

var _SoastaGlobalSetter = require('../../components/Soasta/SoastaGlobalSetter');

var _SoastaGlobalSetter2 = _interopRequireDefault(_SoastaGlobalSetter);

var _App = require('./App.scss');

var _App2 = _interopRequireDefault(_App);

var _login = require('../../redux/modules/login');

var _TermsOfServiceBannerContainer = require('../../components/TermsOfServiceBanner/TermsOfServiceBannerContainer');

var _TermsOfServiceBannerContainer2 = _interopRequireDefault(_TermsOfServiceBannerContainer);

var _WindowSizeContainer = require('../../components/WindowSizeContainer/WindowSizeContainer');

var _WindowSizeContainer2 = _interopRequireDefault(_WindowSizeContainer);

require('../../utils/fontAwesomeLibrary');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cookie = new _universalCookie2.default();

var mapStateToProps = function mapStateToProps(state, _ref) {
    var location = _ref.location;

    var authToken = (0, _user.getAuthToken)(state);
    var baseUrl = (0, _config.getBaseUrl)(state);
    var bidderIsLoaded = (0, _user.isBidderLoaded)(state);
    var browser = (0, _browser.getUiBrowser)(state);
    var classicBaseUrl = (0, _config.getClassicBaseUrl)(state);
    var mainhostLogin = (0, _user.getMainhostLogin)(state);
    var mobile = (0, _browser.isUiMobile)(state);
    var sailthruCustomerId = (0, _config.getSailthruCustomerId)(state);
    var userData = (0, _user.getUserData)(state);
    var userLoggedIn = (0, _user.isUserLoggedIn)(state);
    var whiteLabel = (0, _whiteLabel.isWhiteLabel)(state);
    var logo = (0, _whiteLabel.getWhiteLabelLogo)(state);
    var biddingConsole = location.pathname.includes('/console/');

    var _getWindowSize = (0, _windowSize.getWindowSize)(state),
        windowWidth = _getWindowSize.width;

    var stripePublishKey = (0, _config.getStripePublishKey)(state);
    var termsOfServiceUnknown = (0, _user.isTermsOfServiceUnknown)(state);
    var userDataLoading = (0, _user.isUserDataLoading)(state);

    return {
        authToken: authToken,
        baseUrl: baseUrl,
        bidderIsLoaded: bidderIsLoaded,
        biddingConsole: biddingConsole,
        browser: browser,
        classicBaseUrl: classicBaseUrl,
        logo: logo,
        mainhostLogin: mainhostLogin,
        mobile: mobile,
        sailthruCustomerId: sailthruCustomerId,
        stripePublishKey: stripePublishKey,
        termsOfServiceUnknown: termsOfServiceUnknown,
        userData: userData,
        userDataLoading: userDataLoading,
        userLoggedIn: userLoggedIn,
        whiteLabel: whiteLabel,
        windowWidth: windowWidth
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        fetchBidderDataIfNeeded: _user.fetchBidderDataIfNeeded,
        hydrateClientState: _client.hydrateClientState,
        logOutBidder: _user.logOutBidder,
        openCreateAccountModal: _modal.openCreateAccountModal,
        openDownloadMobileModal: _modal.openDownloadMobileModal,
        openHealthcheckModal: _modal.openHealthcheckModal,
        openLoginModal: _modal.openLoginModal,
        recordAnalyticsForIdentify: _analytics.recordAnalyticsForIdentify,
        submitLogin: _login.submitLogin
    }, dispatch);
};

var App = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(App, _Component);

    function App() {
        var _ref2,
            _this2 = this;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, App);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = App.__proto__ || (0, _getPrototypeOf2.default)(App)).call.apply(_ref2, [this].concat(args))), _this), _this.hydrateClient = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var token, authName, authNuid, authVerify, dateLastShown, hasLoggedInBefore, pageSizeCookie, pageSize, userAgent, browser;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            token = cookie.get('bidder-auth') || '';
                            authName = cookie.get('5Xq_name') || '';
                            authNuid = cookie.get('5Xq_nuid') || '';
                            authVerify = cookie.get('5Xq_nverify') || '';
                            dateLastShown = cookie.get('join-modal-last-seen') || '';
                            hasLoggedInBefore = !!cookie.get('bidder-has-logged-in') || !!token;
                            pageSizeCookie = cookie.get('pagination-page-size') || 24;
                            pageSize = (0, _pagination.getPageSizeFromCookie)(pageSizeCookie);
                            userAgent = navigator.userAgent || '';
                            browser = (0, _getBrowserDataFromUA.getBrowserDataFromUA)(userAgent);
                            _context.next = 12;
                            return _this.props.hydrateClientState({
                                authName: authName,
                                authNuid: authNuid,
                                authVerify: authVerify,
                                browser: browser,
                                dateLastShown: dateLastShown,
                                hasLoggedInBefore: hasLoggedInBefore,
                                pageSize: pageSize,
                                token: token
                            });

                        case 12:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        })), _this.getRequiredData = function () {
            var _this$props = _this.props,
                authToken = _this$props.authToken,
                bidderIsLoaded = _this$props.bidderIsLoaded,
                mainhostLogin = _this$props.mainhostLogin;


            if (!bidderIsLoaded) {
                if (!authToken && mainhostLogin.authVerify) {
                    _this.props.submitLogin(null, null, mainhostLogin);
                } else if (authToken) {
                    _this.props.fetchBidderDataIfNeeded(authToken);
                }
            }
        }, _this.shouldUpdateScroll = function (prevRouterProps, routerProps) {
            // if coming back from an external page, the prevRouterProps will be null
            if (!prevRouterProps) return [0, 0];
            if (prevRouterProps.location.query.page !== routerProps.location.query.page) return true;
            if (prevRouterProps.location.query !== routerProps.location.query) return true;
            return prevRouterProps.location.pathname !== routerProps.location.pathname;
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(App, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this3 = this;

            if (!__DEVELOPMENT__) {
                (0, _script.loadScript)('https://cdn.polyfill.io/v2/polyfill.min.js?features=Intl.~locale.en', true);
            }

            this.hydrateClient().then(function () {
                _this3.props.fetchBidderDataIfNeeded(false, true);
            });

            this.getRequiredData();
            (0, _boomerang.onBoomerangLoaded)().then(function (bjs) {
                if (!bjs) return;
                var Continuity = bjs.plugins.Continuity;

                if (Continuity) {
                    Continuity.frameworkReady();
                }
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('storage', this.onStorage, false);
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps) {
            var nextPath = nextProps.location.pathname;
            var pathname = this.props.location.pathname;


            if (window.LUX && window.LUX.init && nextPath !== pathname) {
                window.LUX.label = pathname;
                window.LUX.init();
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var prevPath = prevProps.location.pathname;
            var pathname = this.props.location.pathname;


            if (window.LUX && window.LUX.send && prevPath !== pathname) {
                window.LUX.send();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                authToken = _props.authToken,
                baseUrl = _props.baseUrl,
                biddingConsole = _props.biddingConsole,
                browser = _props.browser,
                children = _props.children,
                classicBaseUrl = _props.classicBaseUrl,
                location = _props.location,
                logo = _props.logo,
                mainhostLogin = _props.mainhostLogin,
                mobile = _props.mobile,
                sailthruCustomerId = _props.sailthruCustomerId,
                termsOfServiceUnknown = _props.termsOfServiceUnknown,
                userData = _props.userData,
                userDataLoading = _props.userDataLoading,
                userLoggedIn = _props.userLoggedIn,
                whiteLabel = _props.whiteLabel,
                windowWidth = _props.windowWidth;


            var isCheckoutPage = location.pathname.includes('checkout');
            var showDeskPopup = !mobile && !whiteLabel && !isCheckoutPage;
            var showTOSBanner = userLoggedIn && termsOfServiceUnknown && !whiteLabel && !isCheckoutPage && !biddingConsole;
            var isWhiteLabel = !!whiteLabel;

            var app = (0, _jsx3.default)(_react.Fragment, {}, void 0, (0, _jsx3.default)(_DeskPopup2.default, {
                showWidget: showDeskPopup,
                liveBidding: biddingConsole
            }), showTOSBanner && (0, _jsx3.default)(_TermsOfServiceBannerContainer2.default, {}), (0, _jsx3.default)(_reactRouterScroll.ScrollContainer, {
                scrollKey: 'app',
                shouldUpdateScroll: this.shouldUpdateScroll
            }, void 0, (0, _jsx3.default)('div', {
                className: _App2.default.app
            }, void 0, isWhiteLabel && (0, _jsx3.default)(_GoogleTagManager2.default, {
                gtmId: 'GTM-MGNHR3N'
            }), isWhiteLabel && (0, _jsx3.default)(_GoogleTagManager2.default, {
                gtmId: 'GTM-T68B3J7'
            }), (0, _jsx3.default)(_FullStory2.default, {}), (0, _jsx3.default)(_WindowSizeContainer2.default, {}), (0, _jsx3.default)(_AppHeaderMeta2.default, {
                baseUrl: baseUrl,
                pathname: location.pathname,
                whiteLabel: whiteLabel
            }), (0, _jsx3.default)(_SailthruInit2.default, {
                customerId: sailthruCustomerId
            }), (0, _jsx3.default)(_Auth2.default, {
                authToken: authToken,
                mainhostLogin: mainhostLogin,
                recordAnalyticsForIdentify: this.props.recordAnalyticsForIdentify,
                userData: userData,
                userLoggedIn: userLoggedIn
            }), !!browser.isOutdated && (0, _jsx3.default)(_BannerOutdatedBrowser2.default, {
                name: browser.name,
                majorVersion: browser.majorVersion
            }), !biddingConsole && (0, _jsx3.default)(_Header2.default, {
                baseUrl: baseUrl,
                biddingConsole: biddingConsole,
                location: location,
                logo: logo,
                logOutBidder: this.props.logOutBidder,
                mobile: mobile,
                openCreateAccountModal: this.props.openCreateAccountModal,
                openLoginModal: this.props.openLoginModal,
                userLoggedIn: userLoggedIn,
                userDataLoading: userDataLoading,
                whiteLabel: whiteLabel,
                windowWidth: windowWidth
            }), (0, _jsx3.default)('div', {
                className: _App2.default.appContent,
                id: 'main'
            }, void 0, children), !biddingConsole && (0, _jsx3.default)(_Footer2.default, {
                baseUrl: baseUrl,
                classicBaseUrl: classicBaseUrl,
                openDownloadMobileModal: this.props.openDownloadMobileModal,
                openHealthcheckModal: this.props.openHealthcheckModal,
                userData: userData || {},
                whiteLabel: whiteLabel
            }), (0, _jsx3.default)(_Modals2.default, {}), (0, _jsx3.default)(_SegmentTracker2.default, {}), (0, _jsx3.default)(_SoastaGlobalSetter2.default, {}), (0, _jsx3.default)(_BackToTop2.default, {}))));

            var testStrictMode = false;

            return testStrictMode ? (0, _jsx3.default)(_react.StrictMode, {}, void 0, app) : app;
        }
    }]);
    return App;
}(_react.Component), _class.defaultProps = {
    authToken: _propTypes2.default.string,
    userLoggedIn: false
}, _temp2);
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(App);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/App/App.js
// module id = TJgB
// module chunks = 60